import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'components/Icon';

import css from './DropdownMenu.module.scss';

const AdditionalInfo = ({number, text}) => {
    return (
        <div className={css["dropdown-additional-info"]}>
            <span>{number}</span>
            {text}
        </div>
    );
};

AdditionalInfo.propTypes = {
    number: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    text: PropTypes.string
};

class LinkList extends React.Component {
    constructor(props) {
        super(props);

        this.link = this.link.bind(this);
        this.generateTitle = this.generateTitle.bind(this);
    }

    static propTypes = {
        mobile: PropTypes.bool,
        isActive: PropTypes.bool.isRequired,
        link: PropTypes.string,
        linkText: PropTypes.string,
        menuItems: PropTypes.arrayOf(PropTypes.shape({
            href: PropTypes.string,
            language: PropTypes.string,
            target: PropTypes.string,
            text: PropTypes.string,
            title: PropTypes.string
        }))
    }

    state = {
        open: false
    }

    link = () => (
        <a href={this.props.link}>
            {this.props.linkText}
        </a>
    )

    generateTitle() {
        const {
            mobile,
            link,
            linkText
        } = this.props;

        const classNames = classnames(css['dropdown-title'], {
            [css['dropdown-header-link']]: link && !mobile,
        });

        if(mobile) {
            return <h2 className={classNames}>{linkText}</h2>;
        } else {
            return <h2 className={classNames}>{link ? this.link() : linkText}</h2>;
        }
    }

    render() {
        const {
            isActive,
            menuItems,
        } = this.props;

        const classNames = classnames(css['link-list'], {
            [css['active']]: isActive,
        });

        return(
            <ul className={classNames}>
                <li>{this.generateTitle()}</li>
                {menuItems && menuItems.map((l, i) => (
                    <li key={i}>
                        <a href={l.href} target={l.target}>
                            {l.text}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }
}

class DropdownSubmenu extends React.PureComponent {
    static propTypes = {
        columns: PropTypes.array.isRequired,
        mobile: PropTypes.bool.isRequired,
        isActive: PropTypes.bool.isRequired,
    }

    render() {
        const { columns, mobile, isActive } = this.props;

        return (
            <li className={css.submenu}>
                {columns.map((c, i) => (
                    <div key={i}>
                        <LinkList
                            key={i}
                            mobile={mobile}
                            isActive={isActive}
                            additional={undefined}
                            {...c}
                        />
                    </div>
                ))}
            </li>
        );
    }
}

class DropdownMenu extends React.PureComponent {
    static propTypes = {
        columns: PropTypes.array,
        isActive: PropTypes.bool.isRequired,
        mobile: PropTypes.bool.isRequired,
        topMenuLink: PropTypes.shape({
            linkText: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired
        }),
        closeMenu: PropTypes.func.isRequired,
        closeMenuLabel: PropTypes.string.isRequired,
    }

    render() {
        const {
            columns,
            isActive,
            mobile,
            topMenuLink,
            closeMenu,
            closeMenuLabel,
        } = this.props;

        const classNames = classnames(css['column-container-wrapper'], {
            [css['open']]: isActive,
        });

        return (
            <div className={classNames}>
                {topMenuLink ? <a className={css["header-link"]} href={topMenuLink.link}>{topMenuLink.linkText}</a> : undefined}
                <ul>
                    {columns.map((l, i) => (
                        <DropdownSubmenu
                            key={i}
                            columns={l}
                            mobile={mobile}
                            isActive={isActive}
                        />
                    ))}
                </ul>
                <button
                    className={css.close}
                    onClick={closeMenu}
                    title={closeMenuLabel}
                >
                    <Icon className={css.closeIcon} icon="close" />
                </button>
            </div>
        );
    }
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/DropdownMenu.jsx